<template>
    <div class="title">
        <h4>
            {{title}}
        </h4>
    </div>
</template>

<script>
    export default {
        name: 'CardTitle',
        props: {
            title: ''
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/custom/vars';

    .title {
        text-align: left;
        border-bottom: 8px solid $omyfu-red;
        margin-bottom: 20px;
        padding-top: 40px;
    }

</style>



// WEBPACK FOOTER //
// src/components/ui/card/CardTitleComponent.vue